import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import NHLogo from '../components/NHLogo';
import api from '../services/api';

function ForgotPassword() {
  const location = useLocation();
  // GH-11: Login redirects here with state when Cognito returns
  // PASSWORD_RESET_REQUIRED (admin-initiated reset). Pre-fill the email and
  // show a notice so the user understands why they're here instead of seeing
  // a confusing "Invalid email or password" on the login screen.
  const forcedReset = !!location.state?.forcedReset;
  const [email, setEmail] = useState(location.state?.email || '');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    setError('');
    try {
      await api.post('/auth/forgot-password', { email: email.trim() });
      setSent(true);
    } catch (err) {
      setError(err.message || 'Something went wrong');
    }
    setLoading(false);
  };

  return (
    <div style={s.container}>
      <div style={s.card}>
        <div style={s.header}>
          <NHLogo size={40} style={{ justifyContent: 'center' }} />
        </div>

        {sent ? (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>&#9993;</div>
            <h2 style={s.formTitle}>Check Your Email</h2>
            <p style={{ color: '#6b7280', fontSize: 14, marginBottom: 20 }}>
              If an account exists for <strong>{email}</strong>, we sent a password reset link. It expires in 1 hour.
            </p>
            <Link to="/login" style={s.link}>Back to Sign In</Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={s.form}>
            <h2 style={s.formTitle}>Reset Password</h2>
            {forcedReset ? (
              <div style={{
                background: '#fef3c7', border: '1px solid #f59e0b', borderRadius: 8,
                padding: '10px 14px', marginBottom: 16, fontSize: 13, color: '#92400e'
              }}>
                <strong>Password reset required.</strong> Your password was reset by an administrator.
                Send a reset link to your email to set a new password and complete login.
              </div>
            ) : (
              <p style={{ color: '#6b7280', fontSize: 13, marginBottom: 16 }}>
                Enter your email address and we'll send you a link to reset your password.
              </p>
            )}

            {error && <div style={s.error}>{error}</div>}

            <div style={s.field}>
              <label style={s.label}>Email</label>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                placeholder="Enter your email" style={s.input} required />
            </div>

            <button type="submit" style={{ ...s.button, ...(loading ? { opacity: 0.6 } : {}) }} disabled={loading}>
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>

            <div style={{ textAlign: 'center', marginTop: 12 }}>
              <Link to="/login" style={s.link}>Back to Sign In</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

const s = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #7C3AED 0%, #6D28D9 50%, #4C1D95 100%)' },
  card: { background: '#fff', borderRadius: 16, padding: '32px 36px', width: '100%', maxWidth: 400, boxShadow: '0 20px 60px rgba(0,0,0,0.15)' },
  header: { textAlign: 'center', marginBottom: 24 },
  form: {},
  formTitle: { fontSize: 20, fontWeight: 600, color: '#111827', marginBottom: 8, textAlign: 'center' },
  field: { marginBottom: 16 },
  label: { display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 4 },
  input: { width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, outline: 'none', boxSizing: 'border-box' },
  button: { width: '100%', padding: '10px', background: 'linear-gradient(135deg, #7C3AED, #6D28D9)', color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  error: { background: '#fee2e2', border: '1px solid #fca5a5', borderRadius: 8, padding: '8px 12px', marginBottom: 16, fontSize: 13, color: '#991b1b' },
  link: { fontSize: 13, color: '#6D28D9', textDecoration: 'none' },
};

export default ForgotPassword;
